import { cn } from "@/lib/utils";

const SkipToContent = () => {
  return (
    <a
      href="#main-content"
      className={cn(
        "sr-only focus:not-sr-only",
        "fixed top-4 left-4 z-[100]",
        "bg-primary text-primary-foreground",
        "px-6 py-3 rounded-full font-semibold",
        "focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background",
        "transition-transform duration-200",
        "focus:translate-y-0",
        "-translate-y-20"
      )}
    >
      Aller au contenu principal
    </a>
  );
};

export default SkipToContent;
